<mat-card>
	<mat-card-header>
		<mat-card-title>
			CALPADS SSID Match History
			<mat-icon *ngIf="isLoading">
				<mat-spinner diameter="20"> </mat-spinner>
			</mat-icon>
			<help-text-btn class="align-help-text-btn" [helpTextId]="'Calpads_SSID_Match_History'"></help-text-btn>
			<button class="close-button" mat-mini-fab (click)="closeDialog(false)">
				<mat-icon>close</mat-icon>
			</button>
		</mat-card-title>
	</mat-card-header>

	<mat-card-content *ngIf="!isLoading">
		<div *ngIf="!isLoading && calpadsStudentHistories && calpadsStudentHistories.length > 0"
			class="margin-top-md table-responsive">

			<mat-table [dataSource]="calpadsStudentHistoryTableDataSource" class="mat-elevation-z1" matSort>

				<!-- Inquiry Date -->
				<ng-container matColumnDef="INQUIRY_DATE">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						Inquiry Date
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						{{ element.INQUIRY_DATE | cleanDate | simpleDateTime }}
					</mat-cell>
				</ng-container>

				<!-- Status -->
				<ng-container matColumnDef="STATUS">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						Status
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						{{ element.STATUS }}
					</mat-cell>
				</ng-container>

				<!-- Match Type -->
				<ng-container matColumnDef="WINNING_TYPE">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						Match Type
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<!-- API / CALPADS-API -->
						<div *ngIf="element.RESOLVED_USER === 'API' 
        || element.RESOLVED_USER === 'CALPADS-API'" [ngSwitch]="element.WINNING_TYPE">

							<span *ngSwitchCase="'1'">FN, LN, DOB, SSID</span>
							<span *ngSwitchCase="'2'">FN, DOB, SSID</span>
							<span *ngSwitchCase="'3'">FN, LN1, LN2, DOB</span>
							<span *ngSwitchCase="'4'">FN, MN, DOB, Birth City</span>
							<span *ngSwitchCase="'5'">FN, MN, DOB, Birth City</span>
							<span *ngSwitchCase="'11'">Resolved</span>
							<span *ngSwitchCase="'12'">UnResolved</span>
							<span *ngSwitchCase="'13'">No match es</span>
							<span *ngSwitchCase="'14'">Void</span>
							<span *ngSwitchCase="'15'">Empty response</span>
							<span *ngSwitchDefault></span>

						</div>

						<!-- Manual -->
						<div *ngIf="element.STATUS !== 'No Match'
        && element.RESOLVED_USER !== 'API'
        && element.RESOLVED_USER !== 'CALPADS-API'" [ngSwitch]="element.WINNING_TYPE">

							<span *ngSwitchCase="'1'">Manual Match</span>
							<span *ngSwitchCase="'2'">Manual Match</span>
							<span *ngSwitchCase="'3'">Manual Match</span>
							<span *ngSwitchCase="'5'">Manual Match</span>
							<span *ngSwitchCase="'11'">Resolved</span>
							<span *ngSwitchCase="'12'">UnResolved</span>
							<span *ngSwitchCase="'13'">No match et</span>
							<span *ngSwitchCase="'14'">Void</span>
							<span *ngSwitchCase="'15'">Empty response</span>
							<span *ngSwitchDefault></span>

						</div>

						<!-- No Match -->
						<div *ngIf="element.RESOLVED_USER !== 'API'
        && element.STATUS === 'No Match'">
							No Match
						</div>

					</mat-cell>
				</ng-container>

				<!-- SSID -->
				<ng-container matColumnDef="IDENTIFIER_VALUE">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						SSID
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						{{ element.IDENTIFIER_VALUE }}
					</mat-cell>
				</ng-container>

				<!-- Resolved By -->
				<ng-container matColumnDef="RESOLVED_USER">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						Resolved By
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						{{ element.RESOLVED_USER }}
					</mat-cell>
				</ng-container>

				<!-- Resolved Date -->
				<ng-container matColumnDef="RESOLVED_DATE">
					<mat-header-cell *matHeaderCellDef mat-sort-header>
						Resolved Date
					</mat-header-cell>
					<mat-cell *matCellDef="let element">
						{{ element.RESOLVED_DATE | cleanDate | simpleDateTime }}
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="calpadsStudentHistoryDisplayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: calpadsStudentHistoryDisplayedColumns;"></mat-row>

			</mat-table>
		</div>

		<app-msg *ngIf="!isLoading && msg && msg.MSG" [msg]="msg"></app-msg>
	</mat-card-content>
</mat-card>